import { type ReactNode } from 'react';

interface AppHeaderProps {
  /** Optional element rendered at the leading edge of the bar (mobile menu button). */
  leading?: ReactNode;
  /** Right-side actions (refresh button, primary CTA, etc.). */
  actions?: ReactNode;
  /** Identity / role indicator pill, rendered after actions. */
  identity?: ReactNode;
}

/**
 * AppHeader — sticky top bar that lives INSIDE the main content column
 * (not over the sidebar). Mirrors dexhub's per-page header pattern. The
 * brand/logo lives in the Sidebar; this header is for actions + identity
 * only.
 *
 * The dexhub-module build skips this entirely; dexhub provides its own.
 */
export function AppHeader({ leading, actions, identity }: AppHeaderProps) {
  return (
    <header className="sticky top-0 z-20 border-b border-dex-border bg-dex-bg-elevated/80 backdrop-blur-md">
      <div className="flex h-14 items-center gap-3 px-6">
        {leading}
        <div className="flex flex-1 items-center justify-end gap-3">
          {actions}
          {identity}
        </div>
      </div>
    </header>
  );
}
